import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';
import '../styles/AdminLogin.css';

function AdminLogin() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const { login, isAdmin } = useAdmin();
  const navigate = useNavigate();

  // Si déjà connecté, rediriger vers le dashboard
  if (isAdmin) {
    navigate('/admin/dashboard');
    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const success = login(password);
    if (success) {
      navigate('/admin/dashboard');
    } else {
      setError('Code incorrect');
      setShake(true);
      setTimeout(() => setShake(false), 600);
      setPassword('');
    }
  };

  return (
    <div className="admin-login-page">
      <div className={`admin-login-card ${shake ? 'shake' : ''}`}>
        <div className="admin-login-icon">🔐</div>
        <h2>Espace Administration</h2>
        <p>Entrez le code d'accès</p>
        
        <div className="admin-login-form">
          <input
            type="password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            placeholder="Code d'accès"
            className="admin-password-input"
            autoFocus
          />
          {error && <div className="admin-login-error">{error}</div>}
          <button onClick={handleSubmit} className="admin-login-btn">
            Accéder
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
